import React from 'react';
import ReactDOM from 'react-dom/client';
import '@/utils/diagnoser/perfRecorder';
import { Spin } from 'antd';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import App from './App';
import { store } from './redux/store';
const rootNode = document.getElementById('app')!;
const root = ReactDOM.createRoot(rootNode);
const height = window.innerHeight / 2;
root.render(
  <React.Suspense
    fallback={
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: `${height}px`,
        }}
      >
        <Spin />
      </div>
    }
  >
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.Suspense>
);
